import { render, staticRenderFns } from "./dialogWrap.vue?vue&type=template&id=055b71ed&scoped=true&"
import script from "./dialogWrap.vue?vue&type=script&lang=js&"
export * from "./dialogWrap.vue?vue&type=script&lang=js&"
import style0 from "./dialogWrap.vue?vue&type=style&index=0&id=055b71ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b71ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\IdeaProjects\\custom_stage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055b71ed')) {
      api.createRecord('055b71ed', component.options)
    } else {
      api.reload('055b71ed', component.options)
    }
    module.hot.accept("./dialogWrap.vue?vue&type=template&id=055b71ed&scoped=true&", function () {
      api.rerender('055b71ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/calendarchoose/components/dialogWrap.vue"
export default component.exports